<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(1)"
              stacked>Filtrar por período</b-form-radio>

            <b-collapse 
                id="filtroOpcionPeriodo" 
                class="mt-2" 
                v-model="showOpcionesPeriodo">              
              <b-form-group
                label="Desde"
                label-for="fechaDesde"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaDesde" 
                  v-model="filtro.fechaDesde" 
                  type="date"
                  :readonly="filtro.filtroOpcion != 1">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Hasta"
                label-for="fechaHasta"
                :label-cols="labelCols"
                horizontal>
                <b-form-input 
                  id="fechaHasta" 
                  v-model="filtro.fechaHasta" 
                  type="date"
                  :readonly="filtro.filtroOpcion != 1">
                </b-form-input>
              </b-form-group>

              <b-form-group
                label="Proveedor"
                label-for="proveedor"
                :label-cols="labelCols"
                horizontal>
                <b-input-group>
                  <b-input-group-append 
                      v-if="filtro.filtroOpcion == 1"
                      class="filter-search-icons" 
                      @click="seleccionarProveedor">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !filtro.proveedor,
                                    'fa fa-remove': filtro.proveedor  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input 
                    id="proveedor"
                    :value="proveedorNombre"
                    readonly
                    type="text"/>
                </b-input-group>
              </b-form-group>
            </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(2)"
              stacked>Filtrar por presupuestos</b-form-radio>

            <b-collapse 
                id="filtroOpcionPresupuesto" 
                class="mt-2" 
                v-model="showOpcionesPresupuesto">
              <b-form-group
                label="Nro. Presupuesto"
                label-for="numeroPresupuesto"
                :label-cols="labelCols"
                description="Nro de Presupuesto Interno"
                horizontal>
                <b-form-input 
                  id="numero" 
                  v-model="filtro.numeroPresupuesto" 
                  type="text"
                  :readonly="filtro.filtroOpcion != 2">
                </b-form-input>
              </b-form-group>
            </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(3)"
              stacked>Filtrar por órdenes a proveedores</b-form-radio>

            <b-collapse 
                id="filtroOpcionOrden" 
                class="mt-2" 
                v-model="showOpcionesOrden">
              <b-form-group
                label="Nro. Orden"
                label-for="numeroOrdenProveedor"
                :label-cols="labelCols"
                description="Nro de Orden a Proveedor"
                horizontal>
                <b-form-input 
                  id="numero" 
                  v-model="filtro.numeroOrdenProveedor" 
                  type="text"
                  :readonly="filtro.filtroOpcion != 3">
                </b-form-input>
              </b-form-group>
            </b-collapse>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :incluirInactivos="true"
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue';
import moment from 'moment';

export default {
  components: {
    appSearchProveedor: SearchProveedor,
  },
  props: {
    filtroOpcion: {
      type: Number,
      default: 1,
    },

    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    proveedor: {
      type: Object,
      default: null
    },
    numeroPresupuesto: {
      type: Number,
      default: 0,
    },
    numeroOrdenProveedor: {
      type: Number,
      default: 0,
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        filtroOpcion: 1,
        fechaDesde: '',
        fechaHasta: '',
        proveedor: null,
        numeroPresupuesto: 0,
        numeroOrdenProveedor: 0,
        sortByDescending: false
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2,

      showOpcionesPeriodo: true,
      showOpcionesPresupuesto: false,
      showOpcionesOrden: false,
    }
  },
  created() {
      this.filtro.filtroOpcion = this.filtroOpcion;
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
      this.filtro.proveedor = this.proveedor;
      this.filtro.numeroPresupuesto = this.numeroPresupuesto;
      this.filtro.numeroOrdenProveedor = this.numeroOrdenProveedor;
      this.filtro.sortByDescending = this.sortByDescending;
  },
  computed: {
    'proveedorNombre': function() {
      return this.filtro.proveedor? this.filtro.proveedor.nombre.trim() : '';
    },
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.proveedor = null;
      this.filtro.numeroPresupuesto = 0;
      this.filtro.numeroOrdenProveedor = 0;
    },
    seleccionarProveedor() {
      if (this.filtro.proveedor) {
        this.filtro.proveedor = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(proveedor) {
      this.filtro.proveedor = proveedor;
      this.$refs.searchProveedorModal.hide();
    },
  },
  watch: {
    'filtro.filtroOpcion' : function(newVal, oldVal) {
      this.showOpcionesPeriodo = parseInt(newVal) == 1? true : false;
      this.showOpcionesPresupuesto = parseInt(newVal) == 2? true : false;
      this.showOpcionesOrden = parseInt(newVal) == 3? true : false;
    },    
  }    
}
</script>

<style>
</style>
